<template>
  <svg :width="width" :height="height" class="sales-sparkline" @click="$emit('click')">
    <g v-for="(bar, i) in bars" :key="i">
      <title>{{ bar.label }}: {{ bar.tooltip }}</title>
      <!-- leerer Monat: graue Grundlinie -->
      <rect v-if="bar.total === 0" :x="bar.x" :y="height - 2" :width="barWidth" height="2" rx="1" fill="#e0e0e0"></rect>
      <!-- Lagerabsatz (unten, gruen) -->
      <rect v-if="bar.hLager > 0" :x="bar.x" :y="height - bar.hLager" :width="barWidth" :height="bar.hLager" rx="1" fill="#7f915a"></rect>
      <!-- FBA (oben, orange) -->
      <rect v-if="bar.hFba > 0" :x="bar.x" :y="height - bar.hLager - bar.hFba" :width="barWidth" :height="bar.hFba" rx="1" fill="#ff9800"></rect>
    </g>
  </svg>
</template>
<script>
export default {
  name: "SalesSparkline",
  props: {
    series: { type: Array, default: () => [] },
    width: { type: Number, default: 120 },
    height: { type: Number, default: 30 },
  },
  computed: {
    barWidth() {
      const n = this.series.length || 1;
      return Math.max(2, Math.floor((this.width - (n - 1) * 2) / n));
    },
    bars() {
      // Stapel: Lager (gruen) unten + FBA (orange) oben; Skala nach dem staerksten Gesamtmonat
      const max = Math.max(1, ...this.series.map((s) => (s.quantity || 0) + (s.quantityFba || 0)));
      const usable = this.height - 2;
      return this.series.map((s, i) => {
        const lager = s.quantity || 0;
        const fba = s.quantityFba || 0;
        const total = lager + fba;
        const hLager = lager > 0 ? Math.max(1, Math.round((usable * lager) / max)) : 0;
        const hFba = fba > 0 ? Math.max(1, Math.round((usable * fba) / max)) : 0;
        return {
          x: i * (this.barWidth + 2),
          hLager,
          hFba,
          total,
          label: this.formatMonth(s.month),
          tooltip: `${this.$t("procurement.salesSplit.warehouse")} ${lager} · FBA ${fba} · ${this.$t("procurement.salesSplit.total")} ${total}`,
        };
      });
    },
  },
  methods: {
    formatMonth(month) {
      const d = new Date(month);
      return `${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
    },
  },
};
</script>
<style scoped>
.sales-sparkline {
  cursor: pointer;
  display: block;
}
</style>
